<template>
  <div class="third-access">
    <template v-if="showError">
      <div class="access-result">登录失败！</div>
      <div class="access-tip">
        {{ errorMessage || '请回到业务系统重新点击云采购进行跳转' }}
      </div>
    </template>
  </div>
</template>

<script>
import { jxicLoginApi, loginByAccessTokenApi } from '@/api/user'
import Cookies from 'js-cookie'
import { isEmpty } from 'lodash'
import { addQueryToUrl } from '@/utils/utils'

const platformMap = {
  // 云采购平台页面
  purchase: { host: process.env.VUE_APP_LOGIN_JUMP_URL },
  // 专家平台
  expert: { host: process.env.VUE_APP_EXPERT_URL }
}

export default {
  name: 'ThirdAccess',

  data() {
    return {
      showError: false,
      errorMessage: '',
      pageLoading: null
    }
  },

  computed: {
    config() {
      return this.$route.query.config
        ? JSON.parse(this.$route.query.config)
        : {}
    },

    from() {
      // 后面的内容是为了兼容旧版跳转路径，勿删
      return this.config.from || this.$route.params.from
    },

    // 系统内部授权token
    accessToken() {
      return this.$route.query.accessToken || this.$route.query.token
    },

    platform() {
      // 后面的内容是为了兼容旧版跳转路径，勿删
      return this.config.platform || this.$route.query.platform
    },

    page() {
      // 后面的内容是为了兼容旧版跳转路径，勿删
      return this.config.page || this.$route.query.page
    }
  },

  created() {
    this.pageLoading = this.$loading({
      lock: true,
      text: '正在跳转...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    this.loginByThird()
  },

  methods: {
    /**
     * 第三方登录
     */
    loginByThird() {
      console.log('login from ', this.from)
      if (this.from === 'jxic') {
        if (!this.accessToken) {
          window.location.href = process.env.VUE_APP_JXIC_DOMAIN
          return false
        }
        this.loginFromJxic()
      } else {
        if (!this.accessToken) {
          this.$router.replace({
            name: 'Login'
          })
          return false
        }
        this.loginFromJz()
      }
    },

    formatPageConfig(ac, passportConfig) {
      const platform = platformMap[this.platform]

      let pageQuery = {}
      if (this.config.query) {
        pageQuery = Object.assign({}, this.config.query, passportConfig)
      } else if (this.$route.query.pageQuery) {
        const tempRouteQuery = JSON.parse(this.$route.query.pageQuery)
        pageQuery = Object.assign({}, tempRouteQuery, passportConfig)
      }

      return addQueryToUrl(`${platform.host}/blank-page`, {
        ac: ac,
        type: 4,
        targetRouterName: this.page,
        pageParams:
          JSON.stringify(this.config.params) || this.$route.query.pageParams,
        pageQuery: JSON.stringify(pageQuery)
      })
    },

    /**
     * 江咨登录
     */
    loginFromJz() {
      const postData = {
        accessToken: this.accessToken
      }
      loginByAccessTokenApi(postData)
        .then(res => {
          const ac = res.data.ac
          this.showError = false

          this.saveAc(ac)
          window.location.href = this.formatPageConfig(ac)
        })
        .catch(err => {
          console.log('loginFromJz err', err)
          this.pageLoading.close()
          this.showError = true
          if (err?.data?.message) {
            this.errorMessage = err.data.message
            this.$message.error(err.data.message)
          }
        })
    },

    /**
     * 省投登录
     */
    async loginFromJxic() {
      try {
        const postData = {
          token: this.accessToken
        }
        const jxicLoginRes = await jxicLoginApi(postData)
        const _resData = jxicLoginRes.data || {}
        const accessToken = _resData.token
        const accessTokenRes = await loginByAccessTokenApi({ accessToken })
        const ac = accessTokenRes.data?.ac

        if (!this.page) {
          // 如果省投登录没有目标页，则直接前往省投门户
          window.location.href =
            process.env.VUE_APP_JXIC_PORTAL_URL + `?ac=${ac}`
        } else {
          this.saveAc(ac)
          const passportConfig = {
            loginMobile: _resData.mobile,
            loginCompanyName: _resData.companyName
          }
          window.location.href = this.formatPageConfig(ac, passportConfig)
        }
      } catch (err) {
        console.log('loginFromJxic err', err)
        this.pageLoading.close()
        this.showError = true
        if (err?.data?.message) {
          this.errorMessage = err.data.message
          this.$message.error(err.data.message)
        }
      }
    },

    saveAc(ac) {
      Cookies.set('X-JCZH-AC', ac, {
        domain: `.${window.location.hostname
          .split('.')
          .slice(-2)
          .join('.')}`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.third-access {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 48px;

  .access-result {
    font-size: 32px;
  }

  .access-tip {
    font-size: 16px;
    margin-top: 24px;
    color: $text-second-color;
  }
}
</style>
